export const monitorsSortKeys = {
    monitoredPage: 'title',
    monitoredKeyword: 'monitored_keyword',
    averageRankabilityScore: 'average_rankability_score',
    optimalRankabilityScore: 'optimal_rankability_score',
    rankabilityScore: 'rankability_score',
    change: 'change',
    added: 'created_at',
};
